import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import './i18n';
import LanguageSync from './i18n/LanguageSync';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <LanguageSync />
      <App />
    </Provider>  
  // </React.StrictMode> 
);
